import React from 'react'
import ReactDOM from 'react-dom/client'
import { LicenseInfo } from '@mui/x-license'
import App from './App.jsx'
import { ThemeProvider } from './contexts/ThemeContext'

if (import.meta.env.VITE_MUI_LICENSE_KEY) {
	LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY)
}

ReactDOM.createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<ThemeProvider>
			<App />
		</ThemeProvider>
	</React.StrictMode>,
)
